import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ApAnalyticsModule } from '@ap/analytics';
import { ApButtonComponent } from '@ap/button';
import { ApContentModule } from '@ap/content';
import { ApContactInfoComponent } from '@ap/contact-info';
import { ApListItemComponent } from '@ap/list-item';
import { MijnStartChatModule } from '@ap/mijn-start-chat';
import { ApModalComponent } from '@ap/modal';

import { ContextHelpModalComponent } from './context-help-modal.component';

/**
 * @ngdoc module
 * @name ContextHelpModalModule
 **/
@NgModule({
    declarations: [ContextHelpModalComponent],
    imports: [
        ApAnalyticsModule,
        ApButtonComponent,
        ApContactInfoComponent,
        ApListItemComponent,
        CommonModule,
        ApContentModule,
        MijnStartChatModule,
        ApModalComponent
    ],
    exports: [ContextHelpModalComponent]
})
export class ContextHelpModalModule {}
